import React, { useMemo } from 'react'
import Card from 'components/Common/Card'
import { AppFC } from 'types'
import useNavigateTo from 'hooks/useNavigateTo'
import useNavItem from 'hooks/useNavItem'
import { useFeatureFlag } from 'hooks/userFeatureFlag'
import redirectTo from 'utils/redirectTo'
import { getTenantId } from 'utils/getTenantId'
import { getRoleFromPath } from 'utils/helper'

interface INavigationCardProps {
  Icon: any
  /** The nav item's id attribute */
  destination: string
  label?: string
  userId?: string
}

const NavigationCard: AppFC<INavigationCardProps> = ({
  Icon,
  destination,
  className = '',
  label,
  userId = '',
}) => {
  const userRole = getRoleFromPath()
  const tenantId = getTenantId()
  const isV2FeatureFlagOrgEnabled = useFeatureFlag(userId, 'release-v2-org')
  const isV2FeatureFlagUserEnabled = useFeatureFlag(userId, 'release-v2-user')
  const isV2FlagEnabled = isV2FeatureFlagOrgEnabled && isV2FeatureFlagUserEnabled

  const item = useNavItem((i) => i.id === destination)
  const navigate = useNavigateTo(destination)

  const text = useMemo(() => {
    if (label) return label
    return item?.label || ''
  }, [item, label])

  return (
    <Card
      className={`hover:cursor-pointer max-w-[345px] flex-grow-1 border-b-4 border-b-transparent hover:border-b-primary hover:border-b-4 ${className}`}
      onClick={() => {
        if (isV2FlagEnabled) {
          redirectTo(`/${userRole + '-v2'}/${tenantId}/create-business-owner?returnTo=dashboard`)
        } else {
          navigate()
        }
      }}
    >
      <div className="w-full h-full flex flex-col items-center justify-center md:flex-row md:justify-start gap-2 md:gap-[13px]">
        <div className="rounded-full h-[58px] w-[58px] min-h-[58px] min-w-[58px] flex-shrink-0 bg-primary flex justify-center items-center">
          <Icon className="!w-4/5 fill-white" />
        </div>
        <p className="font-semibold text-center lg:text-lg">{text}</p>
      </div>
    </Card>
  )
}

export default NavigationCard
